import { DeliveryMethodType } from '../../../types/BookingType';

export const DELIVERY_METHOD_VAN = [
  DeliveryMethodType.CONSOLIDATED_VAN,
  DeliveryMethodType.DEDICATED_VAN
];
